(ns livefeed.footer.blocked
  (:require
   [livefeed.i18n :refer [translate]]
   [livefeed.icons :as icons]
   [livefeed.message-status :as status]
   [livefeed.util :refer [timestamp->full-date]]))

(defn component [open-modal]
  [:footer.yle-livefeed__footer
   icons/blocked
   [:div.yle-livefeed__footer__text
    (translate :you-are-blocked)
    (when-let [unbanned-at @status/unbanned-at]
      [:span.yle-livefeed__footer__text--unban-time
       (str " " (translate :unbanned-at) " " (timestamp->full-date unbanned-at))])]
   [:button.yle-livefeed__footer__info-button {:on-click open-modal}
    "?"]])
